"use client";

import { useCallback, useMemo, useState } from "react";

export type ToolId =
  | "calculator"
  | "periodic"
  | "ruler"
  | "protractor"
  | "equation"
  | "todo"
  | "magnifier"
  | "tts"
  | "geogebra"
  | "dictionary"
  | "browser"
  | "context7"
  | "askai"
  | "setsquare"
  | "annotator"; // extend as tools grow

export type ToolDockState = {
  activeTool: ToolId | null;
  isOpen: boolean;
};

export function useToolDock(initialTool: ToolId | null = null) {
  const [state, setState] = useState<ToolDockState>({
    activeTool: initialTool,
    isOpen: initialTool != null,
  });

  const openTool = useCallback((tool: ToolId) => {
    setState({ activeTool: tool, isOpen: true });
  }, []);

  const close = useCallback(() => {
    setState((s) => ({ ...s, isOpen: false }));
  }, []);

  const toggleTool = useCallback((tool: ToolId) => {
    setState((s) => {
      const isSame = s.activeTool === tool;
      if (isSame) {
        return { ...s, isOpen: !s.isOpen };
      }
      return { activeTool: tool, isOpen: true };
    });
  }, []);

  return useMemo(
    () => ({ state, openTool, close, toggleTool }),
    [state, openTool, close, toggleTool]
  );
}
